module.exports = __webpack_public_path__ + "static/media/AdminProfilePicture.5b3fc90c.png";